import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';
import { Observable } from 'rxjs';
import { Client } from '../model/client.model';

@Injectable({
  providedIn: 'root'
})
export class ProveedorService extends BaseAPIClass {
  // baseUrl = environment.serverBaseUrl;
  baseUrl = environment.serverBaseUrl;
  public isLoading = false;
  private clientesSearchUrl = this.baseUrl + '/proveedores/search?term=';
  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/proveedores';
  }

  getProveedoresHabilitados(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + '/habilitados');
  }

  getClientes(term: string, user_id: number): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.clientesSearchUrl + term + '&user_id=' + user_id)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }
  getClientesAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getClientesAtUrl2(pagenumber: number): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl + '?page=' + pagenumber)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  updateCliente(id: string, object: any) {
    return this.httpClient.post(this.baseUrl + '/' + id, object);
  }

  search(term: string, user_id: number): Promise<Paginated> {
    this.isLoading = true;

    // console.log(this.clientesSearchUrl+term+ '&user_id='+ user_id);
    return this.httpClient
      .get(this.clientesSearchUrl + term + '&user_id=' + user_id)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  enableCategory(id: number): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }

  /*enableClient(id: any) {

  }*/
}
